import { MissionEventHandler } from "../mission"

export default class ARSMarker extends MissionEventHandler {
	arsMarker = null

	constructor(mission, parentLayer) {
		super(mission)

		this.addedLayer = true
		this.layer = L.layerGroup()
		this.layer.addTo(mymap)
		this.overlay = addOverlay("ARS", this.layer, parentLayer)
	}

	handleMissionIndexJump(targetIndex) {
		let i = targetIndex
		while (i > 0 && i > targetIndex - 100) {
			const message = this.mission.history[i]
			if (message.type === 'SKYLINK_ADV_STATUS') {
				if (this.processStatus(message)) {
					return
				}
			}
			i--
		}
	}

	processStatus(message) {
		if (message.data.remote.protocol.radioStatus === 0 || 
			message.data.remote.position.latitude === 0 ||
			!message.data.local.isLead) return false

		const coord = [message.data.remote.position.latitude, message.data.remote.position.longitude]
		if (this.arsMarker) {
			this.arsMarker.setLatLng(coord)
		} else {
			const icon = L.icon({
				iconUrl: '/images/diamond-thick-blue.png',
				iconSize: [25, 25],
				iconAnchor: [12.5, 12.5]
			})
			this.arsMarker = L.marker(coord, { icon }).addTo(this.layer)
		}
		return true
	}

	handleMissionStep(message) {
		if (message.type == 'SKYLINK_ADV_STATUS') {
			this.processStatus(message)
		}
	}

	cleanup() {
		super.cleanup()
		if (this.arsMarker) {
			this.arsMarker.removeFrom(this.layer)
		}
		if (this.addedLayer) {
			this.layer.removeFrom(mymap)
			removeOverlay(this.overlay)
		}
	}
}